import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { ApiResponse } from '../shared/models/apiResponse';
import { Role } from '../shared/constants';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../shared/services/auth.service';
import { RoleService } from '../shared/services/role.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: MenuItem[] = [];
    userRoles: string[] = [];

    constructor(public layoutService: LayoutService,
        private authService: AuthService,
        private roleService: RoleService
    ) {
        this.model = [
            {
                label: 'Unit Admin',
                items: [
                    {
                        label: 'Purchase Units',
                        icon: 'pi pi-credit-card',
                        routerLink: ['/app/units/purchase']
                    },
                    {
                        label: 'Transfer Units',
                        icon: 'pi pi-arrow-right-arrow-left',
                        routerLink: ['/app/units/transfer']
                    },
                    {
                        label: 'Unit Settings',
                        icon: 'pi pi-cog',
                        routerLink: ['/app/units/settings']
                    }
                ]
            },
            {
                label: 'Testee Admin',
                items: [
                    {
                        label: 'Organizations',
                        icon: 'pi pi-building',
                        routerLink: ['/app/organizations/organization-list']
                    },
                    {
                        label: 'Testees',
                        icon: 'pi pi-user-edit',
                        routerLink: ['/app/testees/testee-list']
                    }
                ]
            },
            {
                label: 'Test Admin',
                items: [
                    {
                        label: 'Available Tests',
                        icon: 'pi pi-folder',
                        routerLink: ['/app/available-tests']
                    },
                    {
                        label: 'Assign Tests',
                        icon: 'pi pi-file-edit',
                        routerLink: ['/app/assign-tests']
                    },
                    {
                        label: 'Test Results',
                        icon: 'pi pi-verified',
                        routerLink: ['/app/test-results']
                    },
                    {
                        label: 'Management',
                        icon: 'pi pi-server',
                        routerLink: ['/app/test-management']
                    }
                ]
            },
            {
                label: 'Resources',
                items: [
                    {
                        label: 'Manuals',
                        icon: 'pi pi-book',
                        routerLink: ['/app/manuals']
                    },
                    {
                        label: 'Downloads',
                        icon: 'pi pi-cloud-download',
                        routerLink: ['/app/downloads']
                    },
                    // {
                    //     label: 'Management',
                    //     icon: 'pi pi-server',
                    //     routerLink: ['/app/resource-management']
                    // }
                ]
            },
            {
                label: 'Client Admin',
                items: [
                    {
                        label: 'Clients',
                        icon: 'pi pi-users',
                        routerLink: ['/app/client-list']
                    },
                    {
                        label: 'Reopen',
                        icon: 'pi pi-replay',
                        routerLink: ['/app/reopen']
                    },
                    {
                        label: 'Audit Trail',
                        icon: 'pi pi-history',
                        routerLink: ['/app/audit-trail']
                    }
                ]
            }
        ];
    }

    ngOnInit() {
        this.hideAdminItems();
    }

    // Admin-only pages: the routes are behind AdminGuard and the APIs behind the admin role;
    // this just keeps non-admins from seeing links they can't use.
    private hideAdminItems() {
        if (this.roleService.isAdmin()) {
            return;
        }

        const adminItems: Record<string, string[]> = {
            'Unit Admin': ['Unit Settings'],
            'Test Admin': ['Management']
        };

        this.model = this.model
            .filter(section => section.label !== 'Client Admin')
            .map(section => adminItems[section.label!]
                ? { ...section, items: section.items!.filter(item => !adminItems[section.label!].includes(item.label!)) }
                : section);
    }
}
